import React from 'react';
import type { ProductAnimation } from '../../data/products';
import RoutingFlow from './RoutingFlow';
import RetailFlow from './RetailFlow';
import FactoryFlow from './FactoryFlow';

const ProductAnimationView: React.FC<{ kind: ProductAnimation }> = ({ kind }) => {
  if (kind === 'routing') return <RoutingFlow />;
  if (kind === 'retail') return <RetailFlow />;
  return <FactoryFlow />;
};

export default ProductAnimationView;
